<app-modal
  [isActive]="isActive"
  [showAcceptFooter]="true"
  (acceptState)="aceeptAndNext()"
  (modalState)="exit()"
>
  <p class="modal-card-title" modal-title>
    <em class="mdi mdi-message-alert has-text-warning mdi-18px" aria-hidden="true"></em>
    {{ 'shared.warning' | translate }}
  </p>

  <div modal-content>
    <div>
      <div class="mb1-rem">
        {{ 'shared.message' | translate }} {{ currentMessageIndex }} {{ 'shared.of' | translate }}
        {{ totalAlerts }}
      </div>

      <div *ngIf="currentTranslate" class="alert alert-warning" role="alert">
        {{ currentMessage | translate }}
      </div>

      <div *ngIf="!currentTranslate" class="alert alert-warning" role="alert">
        {{ currentMessage }}
      </div>
    </div>
  </div>
</app-modal>
